import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import {
  ADD_VIRTUAL_METER,
  DELETE_VIRTUAL_METER,
  GET_ALL_SELECT,
  GET_VIRTUAL_METER
} from "../../../helpers/url_api_constant";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import { Link, useHistory } from "react-router-dom";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useEffect, useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import CreatableSelect from "react-select/creatable";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import { connect } from "react-redux";
import { getPermission } from "../../../helpers/auth_helper";
import moment from "moment";
import { options } from '../../../common/data/projects';
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
import { withTranslation } from "react-i18next";

//i18n

function VirtualMeter(props) {
  const searchObj = { ALIAS_NAME: "", FULL_NAME: "", }; // QTYPOINT_SCADA: "", QTYPOINT_GQMS: "" 
  const createObj = {
    PID: "", ALIAS_NAME: "", FULL_NAME: "", ZONE_PID: null, ZONE_NAME: null, POINT_PID: null, POINT_NAME: null, AREA_PID: null, AREA_NAME: null,
    COMTYPE_PID: null, COMTYPE_NAME: null, CUSTTYPE_PID: null, CUSTTYPE_NAME: null, QUALITYPOINT_PID: null, QUALITYPOINT_NAME: null
  };

  const permission = getPermission();

  const [readonly, setReadonly] = useState(false);
  const [pageAdd, setPageAdd] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);

  const [listCustomerType, setlistCustomerType] = useState([]);
  const [listArea, setlistArea] = useState([]);
  const [listZone, setlistZone] = useState([]);
  const [listPoint, setlistPoint] = useState([]);
  const [listCommunicationType, setlistCommunicationType] = useState([]);
  const [listQualityPoint, setlistQualityPoint] = useState([]);

  const [userActionType, setUserActionType] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();
  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  // DropDown
  const [dropDownCustomerType, setDropDownCustomerType] = useState(null);
  const [dropDownCommunicationType, setDropDownCommunicationType] = useState(null);
  const [dropDownZone, setDropDownZone] = useState(null);
  const [dropDownPoint, setDropDownPoint] = useState(null);
  const [dropDownArea, setDropDownArea] = useState(null);
  const [dropDownQualityPoint, setDropDownQualityPoint] = useState(null);
  // DropDown

  // DropDown Search
  const [dropDownSearchCustomerType, setDropDownSearchCustomerType] = useState(null);
  const [dropDownSearchCommunicationType, setDropDownSearchCommunicationType] = useState(null);
  const [dropDownSearchZone, setDropDownSearchZone] = useState(null);
  const [dropDownSearchPoint, setDropDownSearchPoint] = useState(null);
  const [dropDownSearchArea, setDropDownSearchArea] = useState(null);
  const [dropDownSearchQualityPoint, setDropDownSearchQualityPoint] = useState(null);
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownSearchCustomerType = selected => {
    setDropDownSearchCustomerType(selected);
  };
  const handleSelectDropDownSearchCommunicationType = selected => {
    setDropDownSearchCommunicationType(selected);
  };
  const handleSelectDropDownSearchZone = selected => {
    setDropDownSearchZone(selected);
  };
  const handleSelectDropDownSearchPoint = selected => {
    setDropDownSearchPoint(selected);
  };
  const handleSelectDropDownSearchArea = selected => {
    setDropDownSearchArea(selected);
  };
  const handleSelectDropDownSearchQualityPoint = selected => {
    setDropDownSearchQualityPoint(selected);
  };
  // Handle Set Value DropDown Search //


  const listData = [
    {
      Id: "1",
      Customer: "FreeText_1",
      CustomerName: "Mock up data 001",
      CustomerType: "IND",
      CommunicationType: "AMR",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "MTP",
      Area: "A1",
      BVZoning: "OCS1-BV6",
      BV: "BV2-BV3",
      Estate: "ESIE",
      QualityPoint: "BV6",
    },
    {
      Id: "2",
      Customer: "FreeText_2",
      CustomerName: "Mock up data 002",
      CustomerType: "IND",
      CommunicationType: "AMR",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 3",
      Nomination: "RIL",
      Area: "R",
      BVZoning: "Header",
      BV: "MTP",
      Estate: "RIL",
      QualityPoint: "RA6",
    },
    {
      Id: "3",
      Customer: "FreeText_3",
      CustomerName: "Mock up data 003",
      CustomerType: "SPP",
      CommunicationType: "RTU",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "ESIE",
      Area: "A1",
      BVZoning: "OCS2-BCS",
      BV: "BV6-BCS",
      Estate: "Suksawat",
      QualityPoint: "BV6",
    },
    {
      Id: "4",
      Customer: "FreeText_4",
      CustomerName: "Mock up data 004",
      CustomerType: "SPP",
      CommunicationType: "RTU",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "Suksawat",
      Area: "A1",
      BVZoning: "OCS2-BCS",
      BV: "BV6-BCS",
      Estate: "MTP",
      QualityPoint: "MTP",
    },
    {
      Id: "5",
      Customer: "FreeText_5",
      CustomerName: "Mock up data 005",
      CustomerType: "IND",
      CommunicationType: "AMR",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "ESIE",
      Area: "A1",
      BVZoning: "OCS1-BV6",
      BV: "BV2-BV3",
      Estate: "Suksawat",
      QualityPoint: "BV6",
    },
  ];

  const handleSelectDropDownCustomerType = selected => {
    setDropDownCustomerType(selected);
  };

  const handleSelectDropDownCommunicationType = selected => {
    setDropDownCommunicationType(selected);
  };

  const handleSelectDropDownZone = selected => {
    setDropDownZone(selected);
  };

  const handleSelectDropDownPoint = selected => {
    setDropDownPoint(selected);
  };

  const handleSelectDropDownArea = selected => {
    setDropDownArea(selected);
  };

  const handleSelectDropDownQualityPoint = selected => {
    setDropDownQualityPoint(selected);
  };

  // handleSelectDropDown  SetValue DropDown//

  const SelectStyle ={
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused&&({backgroundColor:'#2E3460'})
    }),
  }

  //sort Column//
  const defaultSorted = [
    {
      dataField: "ALIAS_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        {permission.eVMT && (
          <>
            <OverButton
              onClick={() => {
                setReadonly(false);
                onEdit(row);
                setUserActionType("(Edit)");
              }}
              color="info"
              icon="far fa-edit"
              label="Edit"
            />
            <OverButton
              onClick={() => {
                onDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };
  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "2px",
        fontSize: "12px",
      },
      style: {
        width: "2px",
        fontSize: "12px",
      },
      
      formatter: CountIndexRow,
    },
    {
      dataField: "ALIAS_NAME",
      text: "Virtual Meter",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15px",
        fontSize: "12px",
      },
      style: {
        width: "15px",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "CUSTTYPE",
      text: "Customer Type",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15px",
        fontSize: "12px",
      },
      style: {
        fontSize: "12px",
        width: "15px",
      },
      sort: true,
    },
    {
      dataField: "COMTYPE",
      text: "Communication Type",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15px",
        fontSize: "12px",
      },
      style: {
        width: "15px",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "ZONE",
      text: "Zone",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15px",
        fontSize: "12px",
      },
      style: {
        width: "15px",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "POINT",
      text: "Point",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15px",
        fontSize: "12px",
      },
      style: {
        width: "15px",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "AREA",
      text: "Area",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15px",
        fontSize: "12px",
      },
      style: {
        fontSize: "12px",
        width: "15px",
      },
      sort: true,
    },
    {
      dataField: "QUALITYPOINT",
      text: "Quality Point",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15px",
        fontSize: "12px",
      },
      style: {
        fontSize: "12px",
        width: "15px",
      },
      sort: true,
    },
    // {
    //   dataField: "QTYPOINT_GQMS",
    //   text: "GQMS Tag",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "10%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "10%",
    //   },
    //   sort: true,
    // },
    // {
    //   dataField: "QTYPOINT_SCADA",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "10%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "10%",
    //   },
    //   sort: true,
    // },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "2px",
        fontSize: "12px",
      },
      style: {
        width: "2px",
        fontSize: "12px",
      },
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    //userEffect คือทำงานคล้ายๆ onInIt หมายถึงว่า พอมีการเรียกเข้า การใช้งานใน Component นี้จะทำอันนี้เป็นอันแรก//
    fetchData(searchObj);
    resetSearch();


    ///fixed header table
    let tableId = "virtual-table";
    let scrollY = 334;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  const compare = (a, b) => {
    // console.log(a, b);
    if (a.ALIAS_NAME < b.ALIAS_NAME) {
      return -1;
    }
    if (a.ALIAS_NAME > b.ALIAS_NAME) {
      return 1;
    }
    return 0;
  }
  // objs.sort((a,b) => (a.last_nom > b.last_nom) ? 1 : ((b.last_nom > a.last_nom) ? -1 : 0));

  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      // objs.sort( compare );
      // console.log(objs);
      let option = await post(GET_ALL_SELECT);
      // console.log(option);
      setlistZone(option.data.zoneList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistPoint(option.data.pointList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistArea(option.data.areaList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistCommunicationType(option.data.ctCommuList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistCustomerType(option.data.customerTypeList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistQualityPoint(option.data.qtyPointList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));

      let virtualMeter = await post(GET_VIRTUAL_METER, searchData);
      // console.log(virtualMeter);
      let virtualMeterList = virtualMeter.data.VirtualMeterList.map((obj) => {

        let zone = option.data.zoneList.find((zone) => zone.PID == obj.ZONE_PID);
        if (zone != undefined) {
          zone = zone.ALIAS_NAME;
        }
        // console.log(zone,option.data.zoneList);

        let point = option.data.pointList.find((point) => point.PID == obj.POINT_PID);
        if (point != undefined) {
          point = point.ALIAS_NAME;
        }
        // console.log(point, option.data.pointList);

        let area = option.data.areaList.find((area) => area.PID == obj.AREA_PID);
        if (area != undefined) {
          area = area.ALIAS_NAME;
        }
        // console.log(area,option.data.areaList);

        let commu = option.data.ctCommuList.find((commu) => commu.PID == obj.COMTYPE_PID);
        if (commu != undefined) {
          commu = commu.ALIAS_NAME;
        }
        // console.log(commu, option.data.ctCommuList);

        let customerType = option.data.customerTypeList.find((customerType) => customerType.PID == obj.CUSTTYPE_PID);
        if (customerType != undefined) {
          customerType = customerType.ALIAS_NAME;
        }
        // console.log(customerType, option.data.customerTypeList);

        let qualityPoint = option.data.qtyPointList.find((qualityPoint) => qualityPoint.PID == obj.QUALITYPOINT_PID);
        if (qualityPoint != undefined) {
          qualityPoint = qualityPoint.ALIAS_NAME;
        }

        return { ...obj, AREA: area, ZONE: zone, POINT: point, COMTYPE: commu, CUSTTYPE: customerType, QUALITYPOINT: qualityPoint }
      });

      // console.log(meterList);
      setModelDeviceList(virtualMeterList);
      resetModel();
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    setDropDownSearchArea(null);
    setDropDownSearchCustomerType(null);
    setDropDownSearchCommunicationType(null);
    setDropDownSearchZone(null);
    setDropDownSearchPoint(null);
    setDropDownSearchQualityPoint(null);
    fetchData(searchObj);
  };

  const resetModel = () => {
    // console.log(listArea);
    setCreateModel(createObj);
    setDropDownArea(null);
    setDropDownCustomerType(null);
    setDropDownCommunicationType(null);
    setDropDownZone(null);
    setDropDownPoint(null);
    setDropDownQualityPoint(null);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {
    // console.log(row);
    setCreateModel(row);
    setDropDownZone(listZone.find(obj => obj.value == row.ZONE_PID));
    setDropDownPoint(listPoint.find(obj => obj.value == row.POINT_PID));
    setDropDownArea(listArea.find(obj => obj.value == row.AREA_PID));
    setDropDownCommunicationType(listCommunicationType.find(obj => obj.value == row.COMTYPE_PID));
    setDropDownCustomerType(listCustomerType.find(obj => obj.value == row.CUSTTYPE_PID));
    setDropDownQualityPoint(listQualityPoint.find(obj => obj.value == row.QUALITYPOINT_PID));
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    // console.log(createModel);
    let bResult = true;
    let element = document.querySelectorAll(".form-require")
    element.forEach(el => {
      if (el.classList.contains("is-invalid")) {
        el.classList.remove('is-invalid')
      }
    }
    );
    if (createModel.ALIAS_NAME == "") {
      bResult = false;
    }

    if (createModel.POINT_PID == "" || createModel.POINT_PID == null || createModel.POINT_PID == undefined) {
      document.getElementById("POINT_PID").classList.add('is-invalid');
      bResult = false;
    }

    if (createModel.COMTYPE_PID == "" || createModel.COMTYPE_PID == null || createModel.COMTYPE_PID == undefined) {
      document.getElementById("COMTYPE_PID").classList.add('is-invalid');
      bResult = false;
    }

    if (createModel.CUSTTYPE_PID == "" || createModel.CUSTTYPE_PID == null || createModel.CUSTTYPE_PID == undefined) {
      document.getElementById("CUSTTYPE_PID").classList.add('is-invalid');
      bResult = false;
    }

    if (createModel.QUALITYPOINT_PID == "" || createModel.QUALITYPOINT_PID == null || createModel.QUALITYPOINT_PID == undefined) {
      document.getElementById("QUALITYPOINT_PID").classList.add('is-invalid');
      bResult = false;
    }

    // if (createModel.QTYPOINT_GQMS == "") {
    //   bResult = false;
    // }

    // if (createModel.QTYPOINT_SCADA == "") {
    //   bResult = false;
    // }
    // console.log(bResult);

    return bResult;
  };

  useEffect(function () {

    let ZONE_PID = dropDownZone != null ? dropDownZone.value : null;
    let ZONE_NAME = dropDownZone != null ? dropDownZone.label : null;

    let POINT_PID = dropDownPoint != null ? dropDownPoint.value : null;
    let POINT_NAME = dropDownPoint != null ? dropDownPoint.label : null;

    let AREA_PID = dropDownArea != null ? dropDownArea.value : null;
    let AREA_NAME = dropDownArea != null ? dropDownArea.label : null;

    let COMTYPE_PID = dropDownCommunicationType != null ? dropDownCommunicationType.value : null;
    let COMTYPE_NAME = dropDownCommunicationType != null ? dropDownCommunicationType.label : null;

    let CUSTTYPE_PID = dropDownCustomerType != null ? dropDownCustomerType.value : null;
    let CUSTTYPE_NAME = dropDownCustomerType != null ? dropDownCustomerType.label : null;

    let QUALITYPOINT_PID = dropDownQualityPoint != null ? dropDownQualityPoint.value : null;
    let QUALITYPOINT_NAME = dropDownQualityPoint != null ? dropDownQualityPoint.label : null;

    setCreateModel(preVent => ({
      ...preVent, ZONE_PID: ZONE_PID, ZONE_NAME, POINT_PID, POINT_NAME, AREA_PID, AREA_NAME, COMTYPE_PID, COMTYPE_NAME, CUSTTYPE_PID, CUSTTYPE_NAME, QUALITYPOINT_PID, QUALITYPOINT_NAME,
    }));

  }, [dropDownZone, dropDownPoint, dropDownArea, dropDownCustomerType, dropDownCommunicationType, dropDownQualityPoint]);


  useEffect(function () {

    let ZONE_PID = dropDownSearchZone != null ? dropDownSearchZone.value : null;
    let POINT_PID = dropDownSearchPoint != null ? dropDownSearchPoint.value : null;
    let AREA_PID = dropDownSearchArea != null ? dropDownSearchArea.value : null;
    let COMTYPE_PID = dropDownSearchCommunicationType != null ? dropDownSearchCommunicationType.value : null;
    let CUSTTYPE_PID = dropDownSearchCustomerType != null ? dropDownSearchCustomerType.value : null;
    let QUALITYPOINT_PID = dropDownSearchQualityPoint != null ? dropDownSearchQualityPoint.value : null;

    setSearchModel(preVent => ({
      ...preVent, ZONE_PID: ZONE_PID, POINT_PID, AREA_PID, COMTYPE_PID, CUSTTYPE_PID, QUALITYPOINT_PID,
    }));
  }, [dropDownSearchZone, dropDownSearchPoint, dropDownSearchArea, dropDownSearchCustomerType, dropDownSearchCommunicationType, dropDownSearchQualityPoint]);

  const saveData = async () => {
    // console.log(createModel);
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(ADD_VIRTUAL_METER, createModel);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_VIRTUAL_METER, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.resultDescription);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };
  //Function CURL

  function RenderList(prop) {
    // console.log(prop);
    return (
      <tr>
        <td>{prop.indexlist}</td>
        <td>{prop.data.MeterPointID}</td>
        <td>{prop.data.Customer}</td>
        <td>{prop.data.CustomerType}</td>
        <td>{prop.data.CommunicationType}</td>
        <td>{prop.data.Zone}</td>
        <td>{prop.data.Point}</td>
        <td>{prop.data.Region}</td>
        <td>{prop.data.Area}</td>
        <td>{prop.data.BVZoning}</td>
        <td>{prop.data.BV}</td>
        <td>
          <Button
            className="me-1"
            onClick={() => setPageAdd(true)}
            color="info"
          >
            <i className="far fa-edit"></i>
            &nbsp; Edit
          </Button>
          {/* <Button
            onClick={() => setModalDelete(true)}
            // className="btn-rounded"
            color="danger"
          >
            <i className="fas fa-trash-alt"></i>
            &nbsp; Delete
          </Button> */}
        </td>
      </tr>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  {/* <CardTitle className="card-title mb-4 h4">
                    <h1 className="mb-0 font-size-20">
                      {props.t("Meter")}
                    </h1>
                  </CardTitle> */}

                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Virtual Meter")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Master Data Setting
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Virtual Meter</li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Virtual Meter
                        </Label>
                        <Col sm={8}>
                          {/* <form className="custom-search d-none d-lg-block p-0"> */}

                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                // style={{borderRadius:'0px'}}
                                type="text"
                                style={{ border: 'solid 1px #FFFFFF' }}
                                // style={{ backgroundColor: "#FFFFFF" }}
                                className="form-control rounded-2"
                                placeholder={props.t("Search Virtual Meter")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    ALIAS_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.ALIAS_NAME}
                              />
                              <i className="bx bx-search-alt search-icon" />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              {/* <span className="bx bx-search-alt"></span> */}
                            </div>
                          </div>
                          {/* </form> */}
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Zone
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchZone}
                            onChange={handleSelectDropDownSearchZone}
                            options={listZone}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Point
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchPoint}
                            onChange={handleSelectDropDownSearchPoint}
                            options={listPoint}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Area
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchArea}
                            onChange={handleSelectDropDownSearchArea}
                            options={listArea}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Customer Type
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchCustomerType}
                            onChange={handleSelectDropDownSearchCustomerType}
                            options={listCustomerType}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Communication Type
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchCommunicationType}
                            onChange={
                              handleSelectDropDownSearchCommunicationType
                            }
                            options={listCommunicationType}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Quality Point
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchQualityPoint}
                            onChange={
                              handleSelectDropDownSearchQualityPoint
                            }
                            options={listQualityPoint}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>

                    <Col sm={8}>
                      <div className="d-flex align-items-right justify-content-end mt-4">
                        <Button
                          color="info"
                          className="mt-2 mb-2"
                          onClick={() => onSearch()}
                        >
                          <i className="fas fa-search"></i>
                          &nbsp; Search
                        </Button>

                        <Button color="warning" className="mt-2 mb-2 ms-2" onClick={() => resetSearch()}>
                          <i className="fas fa-redo-alt"></i>
                          &nbsp; Reset
                        </Button>
                      </div>
                    </Col>

                  </Row>

                  <Row>
                    <Col sm="12">
                      <FormGroup className="row">
                        <Col sm={12}>
                          <div className="d-flex align-items-right justify-content-start">
                            {permission.eVMT && (
                              <Button
                                onClick={() => onAdd()}
                                // className="btn-rounded"
                                color="success"
                              // className="mt-3"
                              >
                                <i className="fas fa-plus"></i>
                                &nbsp; Add
                              </Button>
                            )}
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="12" className="mt-2">
                      <div>
                        <BootstrapTable
                          id="virtual-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          defaultSorted={defaultSorted}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="xl" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Virtual Meter {userActionType}</h5>
        </div>
        <div className="modal-body">
          <CardBody>
            <AvForm className="needs-validation">
              <Row>
                <Col md={4}>
                  <FormGroup className="mb-3">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>Virtual Meter</Label>
                    <div className="position-relative">
                      <AvField
                        type="text"
                        disabled={readonly == true || userActionType == "(Edit)"}
                        name="ALIAS_NAME"
                        errorMessage="Enter Virtual Meter"
                        className="form-control basicborder"
                        validate={{ required: { value: true } }}
                        onChange={e =>
                          setCreateModel({
                            ...createModel,
                            ALIAS_NAME: e.target.value,
                          })
                        }
                        value={createModel.ALIAS_NAME}
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-3">
                    <Label>Zone</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownZone}
                      onChange={handleSelectDropDownZone}
                      options={listZone}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-3">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>Point</Label>
                    <Select
                      id="POINT_PID"
                      placeholder="( Blank )"
                      // error={true}
                      isDisabled={readonly}
                      isClearable
                      value={dropDownPoint}
                      onChange={handleSelectDropDownPoint}
                      options={listPoint}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <hr />

              <Row>
                <Col md={4}>
                  <FormGroup className="mb-3">
                    <Label>Area</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownArea}
                      onChange={handleSelectDropDownArea}
                      options={listArea}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-3">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>
                      Customer Type
                    </Label>
                    <Select
                      id="CUSTTYPE_PID"
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownCustomerType}
                      onChange={handleSelectDropDownCustomerType}
                      options={listCustomerType}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-3">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>
                      Communication Type
                    </Label>
                    <Select
                      id="COMTYPE_PID"
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownCommunicationType}
                      onChange={handleSelectDropDownCommunicationType}
                      options={listCommunicationType}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <hr />

              <Row>
                <Col md={4}>
                  <FormGroup className="mb-3">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>
                      Quality Point
                    </Label>
                    <Select
                      id="QUALITYPOINT_PID"
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownQualityPoint}
                      onChange={handleSelectDropDownQualityPoint}
                      options={listQualityPoint}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                {/* <Col md={6}>
                  <FormGroup className="mb-3">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>GQMS Tag</Label>
                    <div className="position-relative">
                      <AvField
                        // disabled
                        // style={{ border: "solid 1px #FFFFFF"}}
                        type="text"
                        // readOnly={readonly}
                        disabled={readonly}
                        name="QTYPOINT_GQMS"
                        errorMessage="Enter GQMS Tag"
                        className="form-control basicborder"
                        validate={{ required: { value: true } }}
                        onChange={e =>
                          setCreateModel({
                            ...createModel,
                            QTYPOINT_GQMS: e.target.value,
                          })
                        }
                        value={createModel.QTYPOINT_GQMS}
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="mb-3">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>SCADA Tag</Label>
                    <div className="position-relative">
                      <AvField
                        // disabled
                        // style={{ border: "solid 1px #FFFFFF"}}
                        type="text"
                        // readOnly={readonly}
                        disabled={readonly}
                        name="QTYPOINT_SCADA"
                        errorMessage="Enter GQMS Tag"
                        className="form-control basicborder"
                        validate={{ required: { value: true } }}
                        onChange={e =>
                          setCreateModel({
                            ...createModel,
                            QTYPOINT_SCADA: e.target.value,
                          })
                        }
                        value={createModel.QTYPOINT_SCADA}
                      />
                    </div>
                  </FormGroup>
                </Col> */}
              </Row>

              <hr />

              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>


          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />
      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />

    </React.Fragment>
  );
}

VirtualMeter.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ VirtualMeter }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(VirtualMeter));

// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//
// const Meter = () => {
//   return (
//     <React.Fragment>
//     <div className="page-content">
//       <Container fluid>
//         <h2>write Html code or structure</h2>
//       </Container>
//     </div>
//     </React.Fragment>
//   )
// }
// export default Meter;
// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//

// ตัวอย่าง Table อันเก่า
{
  /* <Table className="table table-bordered mb-0"> */
}
{
  /* <thead className="table-light">
                            <tr>
                              <th>No.</th>
                              <th>Meter Point ID</th>
                              <th>Customer</th>
                              <th>Customer Type</th>
                              <th>Communication Type</th>
                              <th>Zone</th>
                              <th>Point</th>
                              <th>Region</th>
                              <th>Area</th>
                              <th>BV Zoning</th>
                              <th>BV</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {modelDeviceList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))}
                          </tbody> */
}
{
  /* </Table> */
}

// ตัวแท็บบาร์ข้างล่าง Table
// <br></br>
//                         <nav aria-label="Page navigation example">
//                           <ul className="pagination justify-content-end">
//                             <li className="page-item disabled">
//                               <a className="page-link">Previous</a>
//                             </li>
//                             <li className="page-item active">
//                               <a className="page-link">1</a>
//                             </li>
//                             <li className="page-item disabled">
//                               <a className="page-link">Next</a>
//                             </li>
//                           </ul>
//                         </nav>
